const PaymentSummary = {
  Tooltip: {
    unpaid: 'Nenhum pagamento foi informado',
    pending: 'Aguardando comprovante para confirmação',
    paid: 'Pagamento confirmado'
  }
};

export default PaymentSummary;
